"use client";
import { jsxs as h, jsx as e, Fragment as C } from "react/jsx-runtime";
import { useState as E, useId as T, useRef as L, useEffect as D } from "react";
import { cn as o } from "../utils/cn.js";
import { N3wthProvider as Z } from "../theme/N3wthProvider.js";
import { n3wthTheme as A } from "../theme/n3wthTheme.js";
import { useRouteScrollReset as te } from "../hooks/useRouteScrollReset.js";
import { ReadingOutline as ie } from "./ReadingOutline.js";
import { Heading as F } from "../packages/ui/node_modules/@astryxdesign/core/dist/Heading/Heading.js";
import { Text as I } from "../packages/ui/node_modules/@astryxdesign/core/dist/Text/Text.js";
function $({ as: t = "div", className: n, ...a }) {
  return /* @__PURE__ */ e(t, { className: o("n3wth-site-container", n), ...a });
}
function V({ className: t, ...n }) {
  return /* @__PURE__ */ e("section", { className: o("n3wth-site-section", t), ...n });
}
function W({ className: t, ...n }) {
  return /* @__PURE__ */ e("nav", { className: o("n3wth-site-section-links", t), ...n });
}
const H = { page: 1, section: 2, item: 3 };
function M({ variant: t = "section", level: n, className: a, children: s, ...i }) {
  return /* @__PURE__ */ e(F, { level: n ?? H[t], className: o("n3wth-site-heading", `n3wth-site-heading--${t}`, a), ...i, children: s });
}
function O({ variant: t = "body", as: n = "p", className: a, children: s, ...i }) {
  return /* @__PURE__ */ e(I, { as: n, type: t === "lede" ? "body" : t, display: n === "span" ? "inline" : "block", className: o("n3wth-site-text", `n3wth-site-text--${t}`, a), ...i, children: s });
}
function G({ title: t, level: n = 2, className: a, children: s, ...i }) {
  return /* @__PURE__ */ h("div", { className: o("n3wth-site-doc-section", a), ...i, children: [
    t != null ? /* @__PURE__ */ e(M, { variant: "section", level: n, children: t }) : null,
    s
  ] });
}
function Y({ items: t, className: n, ...a }) {
  return /* @__PURE__ */ e("ul", { className: o("n3wth-site-doc-list", n), ...a, children: t.map((s, i) => /* @__PURE__ */ e("li", { children: s }, i)) });
}
function z({ title: t, level: n = 1, description: a, actions: s, aside: i, align: r = "start", spacing: d = "default", className: u, ...m }) {
  return /* @__PURE__ */ h("header", { className: o("n3wth-site-page-header", i != null && "n3wth-site-page-header--split", r === "center" && "n3wth-site-page-header--center", d === "compact" && "n3wth-site-page-header--compact", u), ...m, children: [
    /* @__PURE__ */ h("div", { className: "n3wth-site-page-header-copy", children: [
      /* @__PURE__ */ e(M, { variant: n === 1 ? "page" : "section", level: n, children: t }),
      a != null && /* @__PURE__ */ e(O, { className: "n3wth-site-description", children: a }),
      s != null && /* @__PURE__ */ e("div", { className: "n3wth-site-actions", children: s })
    ] }),
    i != null && /* @__PURE__ */ e("div", { className: "n3wth-site-page-header-aside", children: i })
  ] });
}
function J({ brand: t, links: n, actions: a, navigationLabel: s = "Primary", navigationId: i, menuLabel: r = "Open menu", menuContent: d, collapseAt: u = "md", className: m, ...p }) {
  const [l, c] = E(!1), N = T(), v = i ?? `site-navigation-${N}`, f = L(null), g = L(null), b = d != null;
  return D(() => {
    if (!l) return;
    g.current?.querySelector(b ? ".n3wth-site-navigation-menu a" : ".n3wth-site-navigation-links a")?.focus();
    const w = window.matchMedia(`(min-width: ${u === "lg" ? 1024 : 768}px)`), y = () => {
      w.matches && c(!1);
    }, S = (k) => {
      g.current?.contains(k.target) || c(!1);
    }, x = (k) => {
      k.key === "Escape" && (c(!1), f.current?.focus());
    };
    return document.addEventListener("pointerdown", S), document.addEventListener("keydown", x), w.addEventListener("change", y), () => {
      document.removeEventListener("pointerdown", S), document.removeEventListener("keydown", x), w.removeEventListener("change", y);
    };
  }, [l, u, b]), /* @__PURE__ */ e("header", { ...p, ref: g, className: o("n3wth-site-navigation", `n3wth-site-navigation--${u}`, m), children: /* @__PURE__ */ h("div", { className: "n3wth-site-navigation-island", "data-nosnippet": !0, children: [
    /* @__PURE__ */ e("div", { className: "n3wth-site-navigation-brand", onClick: () => c(!1), children: t }),
    /* @__PURE__ */ e("nav", { id: v, "aria-label": s, className: "n3wth-site-navigation-links", "data-open": l, onClick: (w) => {
      w.target.closest("a") && c(!1);
    }, children: b ? /* @__PURE__ */ h(C, { children: [
      /* @__PURE__ */ e("div", { className: "n3wth-site-navigation-inline", children: n }),
      /* @__PURE__ */ e("div", { className: "n3wth-site-navigation-menu", children: d })
    ] }) : n }),
    /* @__PURE__ */ e("div", { className: "n3wth-site-navigation-actions", onClick: () => c(!1), children: a }),
    /* @__PURE__ */ e("button", { ref: f, type: "button", className: "n3wth-site-navigation-toggle", "aria-label": l ? "Close menu" : r, "aria-controls": v, "aria-expanded": l, onClick: () => c((w) => !w), children: /* @__PURE__ */ e("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", "aria-hidden": "true", children: l ? /* @__PURE__ */ e("path", { d: "m6 6 12 12M6 18 18 6" }) : /* @__PURE__ */ e("path", { d: "M4 6h16M4 12h16M4 18h16" }) }) })
  ] }) });
}
function K({ onSubmit: t, label: n = "Notes and new work across design, technology, AI, and the things I’m exploring.", buttonLabel: a = "Subscribe", successMessage: s = "Thanks. You are on the list.", errorMessage: i = "That did not go through. Try again.", compact: r = !1, className: d, ...u }) {
  const m = T(), [p, l] = E("idle"), c = p === "sending" || p === "done";
  async function N(v) {
    v.preventDefault();
    const f = v.currentTarget, g = new FormData(f).get("email");
    if (!(typeof g != "string" || !f.reportValidity())) {
      l("sending");
      try {
        await t(g.trim()), f.reset(), l("done");
      } catch {
        l("error");
      }
    }
  }
  return /* @__PURE__ */ h("form", { ...u, className: o("n3wth-site-signup", r && "n3wth-site-signup--compact", "ph-no-capture", "ph-mask", d), "data-ph-no-capture": !0, onSubmit: N, noValidate: !1, children: [
    /* @__PURE__ */ e("label", { htmlFor: m, className: "n3wth-site-signup-label", children: n }),
    /* @__PURE__ */ h("div", { className: "n3wth-site-signup-row", children: [
      /* @__PURE__ */ e("input", { id: m, name: "email", type: "email", required: !0, autoComplete: "email", inputMode: "email", placeholder: r ? "Email to subscribe" : "you@example.com", disabled: c, className: "ph-no-capture ph-mask", "data-ph-no-capture": !0 }),
      /* @__PURE__ */ e("button", { type: "submit", disabled: c, "aria-label": r ? "Subscribe" : void 0, children: r ? /* @__PURE__ */ e("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: /* @__PURE__ */ e("path", { d: "M4 12h16m-6-6 6 6-6 6" }) }) : a })
    ] }),
    /* @__PURE__ */ e("p", { "aria-live": "polite", className: "n3wth-site-signup-status", children: p === "done" ? s : p === "error" ? i : null })
  ] });
}
function Q({ brand: t = /* @__PURE__ */ e("a", { href: "https://n3wth.com", children: "Oliver Newth" }), links: n, sourceHref: a = "https://github.com/n3wth/n3wth", legalLinks: s, signup: i, inlineSignup: r = !1, children: d, className: u, ...m }) {
  const p = n ?? /* @__PURE__ */ h(C, { children: [
    /* @__PURE__ */ e("a", { href: "https://n3wth.com/library", children: "Library" }),
    /* @__PURE__ */ e("a", { href: "https://skills.n3wth.com", children: "Skills" }),
    /* @__PURE__ */ e("a", { href: "https://r3.n3wth.com", children: "r3" }),
    /* @__PURE__ */ e("a", { href: "https://docs.n3wth.com", children: "Docs" }),
    /* @__PURE__ */ e("a", { href: "https://n3wth.com/contact", children: "Contact" }),
    /* @__PURE__ */ e("a", { href: a, children: "GitHub" }),
    s
  ] });
  return /* @__PURE__ */ e("footer", { ...m, className: o("n3wth-site-footer", u), children: /* @__PURE__ */ h($, { "data-nosnippet": !0, children: [
    i != null && !r && /* @__PURE__ */ e("div", { className: "n3wth-site-footer-signup", children: i }),
    /* @__PURE__ */ h("div", { className: "n3wth-site-footer-row", children: [
      t != null && /* @__PURE__ */ e("div", { className: "n3wth-site-footer-brand", children: t }),
      /* @__PURE__ */ e("nav", { "aria-label": "Footer", className: "n3wth-site-footer-links", children: p }),
      i != null && r && /* @__PURE__ */ e("div", { className: "n3wth-site-footer-inline-signup", children: i })
    ] }),
    d != null && /* @__PURE__ */ e("div", { className: "n3wth-site-footer-meta", children: d })
  ] }) });
}
export {
  Z as N3wthProvider,
  z as PageHeader,
  ie as ReadingOutline,
  $ as SiteContainer,
  Y as SiteDocList,
  G as SiteDocSection,
  Q as SiteFooter,
  M as SiteHeading,
  J as SiteNavigation,
  V as SiteSection,
  W as SiteSectionLinks,
  K as SiteSignup,
  O as SiteText,
  A as n3wthTheme,
  te as useRouteScrollReset
};
//# sourceMappingURL=index.js.map
